// 非同期で作成されるhtmlはcommon.jsのcarouselスタイルが適用されないため

export const applyCarouselStyle = (carouselIdList: string[])=> {
    carouselIdList.forEach(carouselId => { return new window._carousel("#" + carouselId); })
}
